export const ADD_ARTICLE = "ADD_ARTICLE";

export const X_TOKEN = 'x-tourizo-token';
export const LOGIN_URL = '/#/login';